var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 25.3334V22.6667H8.00004V13.3334C8.00004 11.4889 8.5556 9.85002 9.66671 8.41669C10.7778 6.98335 12.2223 6.04446 14 5.60002V4.66669C14 4.11113 14.1945 3.63891 14.5834 3.25002C14.9723 2.86113 15.4445 2.66669 16 2.66669C16.5556 2.66669 17.0278 2.86113 17.4167 3.25002C17.8056 3.63891 18 4.11113 18 4.66669V5.60002C19.7778 6.04446 21.2223 6.98335 22.3334 8.41669C23.4445 9.85002 24 11.4889 24 13.3334V22.6667H26.6667V25.3334H5.33337ZM16 29.3334C15.2667 29.3334 14.6389 29.0722 14.1167 28.55C13.5945 28.0278 13.3334 27.4 13.3334 26.6667H18.6667C18.6667 27.4 18.4056 28.0278 17.8834 28.55C17.3612 29.0722 16.7334 29.3334 16 29.3334Z",
    fill: "#063556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertActive);
export default __webpack_public_path__ + "static/media/AlertActive.eed2b88e54f5c1d58e477246db72bca6.svg";
export { ForwardRef as ReactComponent };